import { render, staticRenderFns } from "./CreateStepHeader.vue?vue&type=template&id=373712fa&scoped=true&"
import script from "./CreateStepHeader.vue?vue&type=script&lang=js&"
export * from "./CreateStepHeader.vue?vue&type=script&lang=js&"
import style0 from "./CreateStepHeader.vue?vue&type=style&index=0&id=373712fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373712fa",
  null
  
)

export default component.exports